import './delete-validation-overlay.scss'

import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { defineComponent } from 'vue';

export const DeleteValidationOverlay = defineComponent({
    mixins: [reactiveVueMixin],
    props: ['message'],
    template: require('./delete-validation-overlay.html'),
    data() {
        return {
            checkIcon: faCheck,
            crossIcon: faTimes,
            display: false,
        }
    },
    methods: {
        onCheckClick() {
            this.$parent?.$emit('deletion-validated-topic')
        },
        onCrossClick() {
            this.$parent?.$emit('deletion-canceled-topic')
        },
    },
})
